<template>
  <div class="custom-input favorite-selection" :class="displayHotel?'matched-height':''">
    <fa fa-class="hotel"/>

    <div class="input-inner">
      <div :class="getLabelClass">
        {{ label }}
      </div>

      <select-input name="favorite-location"
                    class="favorite"
                    placeholder="home.form.favorite.placeholder.location"
                    :options="options.locations"
                    v-model="value.location"
                    :required="false"
                    :allow-custom-options="true"
                    @input="loadHotels"
                    :show-pointer="false"
                    :deselect="deselect"
                    :searchable="true"
                    options-label="city"
      />

      <!--appliquer la class onlineResult pour la hauteur du bloc services + errorMessage width 150%-->

      <select-input v-if="displayHotel"
                    name="favorite-hotel"
                    class="favorite hotel fade-in"
                    placeholder="home.form.favorite.placeholder.hotel"
                    :options="options.hotels"
                    v-model="value.hotel"
                    :required="false"
                    :allow-custom-options="true"
                    :deselect="deselect"
                    :searchable="true"
                    options-label="name"
      />

      <error v-if="displayError"
             style="position: absolute; top: 85px; width:100%"
             custom-class="error"
      >
        {{ errorMessage }}
      </error>
    </div>
  </div>
</template>

<script>
import selectInput from '@/components/frontoffice/form/baseInput/select'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import CommonApi from '@/api/commonApi'
import error from '@/components/frontoffice/form/error'
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    selectInput,
    error,
    fa
  },

  mixins: [formMethods],

  props: {
    value: {
      type: Object,
      required: true
    },
    favoriteLocations: Array,
    unloggedInfos: Object,
    isPrelogged: {
      type: Boolean,
      default: false
    },
    deselect: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      displayError: false,
      isLoaded: false,
      commonApi: new CommonApi(),
      options: {
        locations: [],
        hotels: []
      }
    }
  },

  created () {
    if (this.favoriteLocations) {
      this.options.locations = this.favoriteLocations
    } else {
      let uniqueChain = this.unloggedInfos ? this.unloggedInfos.companyUniqueChain : null

      this.commonApi.companyFavoriteLocations(uniqueChain)
        .then(response => {
          this.options.locations = response.data.data
          this.isLoaded = true
        })
    }

    if (this.value.location) {
      this.loadHotels(this.value.location)
    }
  },

  methods: {
    loadHotels (location) {
      if (location) {
        let uniqueChain = this.unloggedInfos ? this.unloggedInfos.companyUniqueChain : null

        this.commonApi.companyFavoriteHotels(location.id, uniqueChain)
          .then(response => {
            this.options.hotels = []

            for (let i in response.data.data) {
              if (response.data.data.hasOwnProperty(i)) {
                this.options.hotels.push(response.data.data[i].hotel)
              }
            }
          })
      }
    }
  },

  computed: {
    displayHotel () {
      return this.value.location !== null && this.options.hotels.length
    },

    label () {
      let key = 'home.form.favorite.'

      return this.$t(key += this.isPrelogged
        ? 'preloggedLabel'
        : 'label'
      )
    }
  },

  watch: {
    value (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
